import * as React  from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import Base from './base';
import { Field} from 'redux-form';
import FormSelect from "../../FormComponents/formSelect";
import * as CommonUtil from '../../../common/util';

class Country extends Base{
    constructor(props){
        super(props);
    }

    renderOnCard() {
        return (
            <div></div>
        )
    }
    renderOnGrid() {
        return (
            <div></div>
        )
    }
    renderOnDetail() {
        let {renderType, data, showLabel=false} = this.props;
        if(Array.isArray(data))
            data = data[0];
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{(data.Value)?data.Value:'-'}</li>)
                :
                    (data.Value?data.Value:'-')
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<React.Fragment><label data-test={data.Label}>{data.Label} </label>{data.Value}</React.Fragment>)
                :
                    (data.Value?data.Value:'-')
        } else{
            return (showLabel) ?
                    (<React.Fragment><label data-test={data.Label}>{data.Label}: </label>{data.Value}</React.Fragment>)
                :
                    (data.Value?data.Value:'-')
        }
    }

    renderOnCreate(){
        let countryOptions=[
            {value:"US",label:"United States"},
            {value:"CA",label:"Canada"},
            {value:"GR",label:"Greece"},
            {value:"IN",label:"India"},
            {value:"KE",label:"Kenya"},
            {value:"GB",label:"United Kingdom"}
        ]
        return(
            <Field
            component={FormSelect}
            wrapperClass="mrNone"
            className=""
            inputClass="mrNone"
            divClass="flexGrow"
            name={this.props.data[0].Name}
            options={CommonUtil.sortArrayByKey(countryOptions,'label')}
            selected={this.props.selectedCountry}
            isDisabled={this.props.data[0].IsNonEditable}
            setDefaultLocationValue={(value)=>{this.props.setDefaultLocationValue(value);this.props.changePlaceholder(value)}}
            type={this.props.data[0].FieldType}
        />
        )
       
    }
}

export default Country;